"use client";

import React from "react";
import { createIcon } from "@chakra-ui/react";

const ListIcon = createIcon({
  displayName: "ListIcon",
  viewBox: "0 0 45 24",
  path: (
    <>
      <path
        d="M10,4.8V0h35v4.8H10ZM10,14.4v-4.8h35v4.8H10ZM10,24v-4.8h35v4.8H10ZM2.5,4.8c-.71,0-1.3-.23-1.78-.69-.48-.46-.72-1.03-.72-1.71S.24,1.15.72.69c.48-.46,1.07-.69,1.78-.69s1.3.23,1.78.69c.48.46.72,1.03.72,1.71s-.24,1.25-.72,1.71c-.48.46-1.07.69-1.78.69ZM2.5,14.4c-.71,0-1.3-.23-1.78-.69-.48-.46-.72-1.03-.72-1.71s.24-1.25.72-1.71c.48-.46,1.07-.69,1.78-.69s1.3.23,1.78.69c.48.46.72,1.03.72,1.71s-.24,1.25-.72,1.71c-.48.46-1.07.69-1.78.69ZM2.5,24c-.71,0-1.3-.23-1.78-.69-.48-.46-.72-1.03-.72-1.71s.24-1.25.72-1.71c.48-.46,1.07-.69,1.78-.69s1.3.23,1.78.69c.48.46.72,1.03.72,1.71s-.24,1.25-.72,1.71c-.48.46-1.07.69-1.78.69Z"
        fill="currentColor"
      />
    </>
  ),
  defaultProps: {
    boxSize: "1em",
  },
});

export default ListIcon;
